// api/Users
import request from '@utils/request'

const url = 'api/Users/'

/**
 *
 * 登录
 * @export
 * @param {*} data
 * @return {*}
 */
export function Login (data) {
  return request({
    url: url + 'Login',
    method: 'post',
    data
  })
}

/**
 *
 * 获取当前登录用户的信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMyInfo (data) {
  return request({
    url: url + 'GetMyInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 修改当前登录用户信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateMyInfo (data) {
  return request({
    url: url + 'UpdateMyInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 修改密码
 * @export
 * @param {*} data
 * @return {*}
 */
export function ChangeMyPwd (data) {
  return request({
    url: url + 'ChangeMyPwd',
    method: 'post',
    data
  })
}

/**
 *
 * 分页查询用户信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryUsersInfo (data) {
  return request({
    url: url + 'QueryUsersInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 分销商下拉（用户管理）
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryDistributor (data) {
  return request({
    url: url + 'QueryDistributor',
    method: 'post',
    data
  })
}

/**
 *
 * 添加用户信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function AddUserInfo (data) {
  return request({
    url: url + 'AddUserInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 删除用户信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteUserInfo (data) {
  return request({
    url: url + 'DeleteUserInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 编辑用户信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateUserInfo (data) {
  return request({
    url: url + 'UpdateUserInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 重置密码
 * @export
 * @param {*} data
 * @return {*}
 */
export function ResetPwd (data) {
  return request({
    url: url + 'ResetPwd',
    method: 'post',
    data
  })
}

/**
 *
 * 重置密码
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryUserAlarmSetting (data) {
  return request({
    url: url + 'QueryUserAlarmSetting',
    method: 'post',
    data
  })
}
